import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ViewCheckboxField = _resolveComponent("ViewCheckboxField");
    const _component_ViewSignatureField = _resolveComponent("ViewSignatureField");
    const _component_ViewLinkField = _resolveComponent("ViewLinkField");
    const _directive_tooltip = _resolveDirective("tooltip");
    return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['view-field-container']),
        style: _normalizeStyle({ top: _ctx.top, left: _ctx.left, 'font-size': _ctx.fontSize, height: _ctx.height, width: _ctx.width })
    }, [
        _createElementVNode("div", {
            class: _normalizeClass(['view-field', _ctx.fieldType, _ctx.fieldSource, { completed: _ctx.completed }])
        }, [
            (_ctx.field.type === _ctx.FieldType.Check)
                ? (_openBlock(), _createBlock(_component_ViewCheckboxField, {
                    key: 0,
                    value: _ctx.field.value
                }, null, 8, ["value"]))
                : (_ctx.field.type === _ctx.FieldType.Signature)
                    ? (_openBlock(), _createBlock(_component_ViewSignatureField, {
                        key: 1,
                        "signature-biometric": _ctx.field.signatureBiometric,
                        "full-name": _ctx.fullName
                    }, null, 8, ["signature-biometric", "full-name"]))
                    : (_ctx.field.type === _ctx.FieldType.Link)
                        ? (_openBlock(), _createBlock(_component_ViewLinkField, {
                            key: 2,
                            link: _ctx.field.value
                        }, null, 8, ["link"]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createTextVNode(_toDisplayString(_ctx.value), 1)
                        ], 64))
        ], 2)
    ], 4)), [
        [_directive_tooltip, _ctx.tooltip]
    ]);
}
